/** @jsx jsx */
import { Mode } from '../types';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import ColorCard from './ColorCard';
import { getOptions, getWidth } from '../utils';
import { css, jsx } from '@emotion/react';
import { N0, N40 } from '@atlaskit/theme/colors';
export const ColorPaletteMenuWithoutAnalytics = ({
  createAnalyticsEvent,
  onChange,
  palette,
  selectedColor,
  checkMarkColor,
  label = 'Color picker',
  cols = 6,
  mode = Mode.Standard
}) => {
  const createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');
  const changeAnalyticsCaller = () => {
    if (createAnalyticsEvent) {
      return createAndFireEventOnAtlaskit({
        action: 'clicked',
        actionSubject: 'color-palette-menu',
        attributes: {
          componentName: 'color-picker',
          packageName: "@atlaskit/color-picker",
          packageVersion: "3.2.13"
        }
      })(createAnalyticsEvent);
    }
    return undefined;
  };
  const handleChange = value => {
    onChange(value, changeAnalyticsCaller());
  };
  const {
    options,
    value: selectedValue
  } = getOptions(palette, selectedColor);
  const fullLabel = `${label}, ${selectedValue.label} selected`;
  return jsx("div", {
    "aria-label": fullLabel,
    role: "radiogroup",
    css: [colorPaletteMenuStyles, mode === Mode.Standard && colorPaletteMenuStandardStyles],
    style: {
      width: `${getWidth(cols, mode)}px`
    }
  }, jsx("div", {
    css: [colorPaletteContainerStyles, mode === Mode.Compact && colorPaletteContainerCompactStyles]
  }, options.map(({
    label,
    value
  }) => jsx("div", {
    css: colorCardWrapperStyles,
    key: value
  }, jsx(ColorCard, {
    label: label,
    value: value,
    checkMarkColor: checkMarkColor,
    isOption: true,
    selected: value === selectedValue.value,
    onClick: handleChange,
    onKeyDown: handleChange
  })))));
};
export default withAnalyticsContext({
  componentName: 'color-picker',
  packageName: "@atlaskit/color-picker",
  packageVersion: "3.2.13"
})(withAnalyticsEvents()(ColorPaletteMenuWithoutAnalytics));
const colorCardWrapperStyles = css({
  display: 'flex',
  margin: "var(--ds-space-025, 2px)",
  height: "var(--ds-space-400, 32px)"
});
const colorPaletteContainerStyles = css({
  display: 'flex',
  flexWrap: 'wrap',
  padding: "var(--ds-space-050, 4px)"
});
const colorPaletteContainerCompactStyles = css({
  padding: "var(--ds-space-0, 0)"
});
const colorPaletteMenuStyles = css({
  display: 'flex',
  position: 'relative',
  margin: "var(--ds-space-0, 0)",
  backgroundColor: `var(--ds-surface-overlay, ${N0})`
});
const colorPaletteMenuStandardStyles = css({
  borderRadius: "var(--ds-border-radius-100, 3px)",
  boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${N40}, 0 0 8px ${N40}`})`
});